/* eslint-disable react/display-name */
import React, { RefAttributes } from 'react';
import { Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { ButtonStylesProps as StylesProps, Button as ButtonStyled } from './ButtonStyles';

type Props = {
  id?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  to?: string;
  loading?: boolean;
  children: JSX.Element | JSX.Element[] | string | undefined;
} & Partial<StylesProps> &
  RefAttributes<HTMLButtonElement>;

export const Button: React.FC<Props> = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      id,
      className,
      type = 'button',
      variant = 'primary',
      disabled = false,
      onClick,
      to,
      size,
      children,
      dense = false,
      loading = false,
      ...rest
    }: Props,
    ref,
  ) => {
    const history = useHistory();

    return (
      <ButtonStyled
        {...rest}
        id={id}
        ref={ref}
        className={className}
        type={type}
        variant={variant}
        disabled={disabled}
        size={size}
        dense={dense}
        onClick={to ? () => history.push(to) : onClick}>
        {loading && (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            className="mr-2"
            role="status"
            aria-hidden="true"
          />
        )}
        {children}
      </ButtonStyled>
    );
  },
);
